import { usePathname } from 'next/navigation';
import trimSpacesAndTrailingSlash from '../../src/utils/trimSpacesAndTrailingSlash';
import isRouteMatchForPath from '../../src/utils/server/isRouteMatchForPath';
const RouteMock = t0 => {
  const {
    children,
    path
  } = t0;
  const currentPath = usePathname();
  const trimmedPath = trimSpacesAndTrailingSlash(path);
  if (isRouteMatchForPath(trimmedPath, currentPath)) {
    return children;
  }
  return null;
};
export default RouteMock;